import { PortfolioInferredPositions } from '@/cip/_openapi/portfolio-optimizer';
import { roundedPercents } from 'utils/number-utils';

export const positionKey = (p: { sId: string; scId?: string | null }) => `${p.sId}-${p.scId ?? ''}`;

export const buildWeightMap = (portfolio: PortfolioInferredPositions): Record<string, string> => {
    const sorted = [...(portfolio.positions ?? [])].sort((a, b) => b.weight - a.weight);
    const percents = roundedPercents(
        sorted.map((p) => p.weight),
        2,
    );
    const map: Record<string, string> = {};
    sorted.forEach((p, i) => {
        map[positionKey(p)] = String(percents[i]);
    });
    return map;
};
